<!-- 业绩材料 -->
<template>
	<div v-if="quarterInfo.announcementLink" class="data-wrapper material-data">
		<div class="material-header">
			<p class="wrapper-title">{{ title }}</p>
		</div>
		<div class="material-content">
			<div class="material-wrapper" @click="openAnnouncement(quarterInfo)">
				<div class="material-type-time">
					<span class="material-type material-type-announcement">{{
						$t('enterprise.results-announcement')
					}}</span>
				</div>
				<p class="material-title">{{ quarterInfo.announcementTitle }}</p>
			</div>
			<div v-if="quarterInfo.roundupLink" class="material-wrapper" @click="openSummary(quarterInfo)">
				<div class="material-type-time">
					<span class="material-type material-type-roundup">{{ $t('enterprise.results-summary') }}</span>
				</div>
				<p class="material-title">{{ quarterInfo.roundupTitle }}</p>
			</div>
			<div v-if="quarterInfo.showLink" class="material-wrapper" @click="openExternalFile(quarterInfo)">
				<div class="material-type-time">
					<span class="material-type material-type-show">{{ $t('enterprise.earnings-presentation') }}</span>
				</div>
				<p class="material-title">{{ quarterInfo.showTitle }}</p>
			</div>
		</div>
	</div>
</template>

<script setup>
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';

const props = defineProps({
	quarterInfo: {
		type: Object,
		default: () => ({})
	},
	title: {
		type: String,
		default: ''
	}
});

const { viewModule } = useModuleNavigation();
const openAnnouncement = item => {
	viewModule('quarterly_performance_announcement', item);
};
const openSummary = item => {
	viewModule('quarterly_performance_summary', item);
};
const openExternalFile = item => {
	viewModule('quarterly_performance_custom', item);
};
</script>

<style lang="less" scoped>
@import '@/style/mixin/mixins';
@import '@/style/mixin/text-overflow';
@import '@/style/mixin/border-radius';

.data-wrapper {
	margin-bottom: 0.14rem;
	padding: 0.14rem 0.12rem;
	border-radius: 0.06rem;
	background: #fff;
	overflow: hidden;

	.wrapper-title {
		color: #333;
		font-family: 'PingFang SC';
		font-size: 0.16rem;
		font-style: normal;
		font-weight: 500;
		line-height: 0.22rem;
	}
}

.material-data {
	padding-bottom: 0;
	.material-wrapper {
		padding: 0.14rem 0;
	}
	.material-wrapper + .material-wrapper {
		.thinner-border-top(#e8eaef);
	}

	.material-title {
		color: #333;
		font-family: 'PingFang SC';
		font-size: 0.14rem;
		font-style: normal;
		font-weight: 500;
		line-height: 0.2rem;
		.text-overflow-multi-row();
	}
	.material-type-time {
		margin-bottom: 0.08rem;
		display: flex;
		align-items: center;
	}
	.material-type {
		height: 0.16rem;
		padding: 0 0.06rem;
		border-radius: 1px;
		background: #3f5bd6;
		color: #fff;
		font-family: 'PingFang SC';
		font-size: 0.1rem;
		font-style: normal;
		font-weight: 400;
		line-height: 0.16rem;

		&-announcement {
			background: #f76a2b;
		}
		&-roundup {
			background: #9673ff;
		}
	}
	.material-time {
		margin-left: 0.08rem;
		color: #989898;
		font-family: 'PingFang SC';
		font-size: 0.1rem;
		font-style: normal;
		font-weight: 400;
		line-height: 0.16rem;
	}
}
</style>
